import { render, staticRenderFns } from "./device-list.vue?vue&type=template&id=123afc68&scoped=true&"
import script from "./device-list.vue?vue&type=script&lang=js&"
export * from "./device-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123afc68",
  null
  
)

export default component.exports